module.exports = __webpack_public_path__ + "static/media/olivergreen.66924760.png";